import Glide from '@glidejs/glide';

/**
 * Ensure that each hero slide is an equal height.
 */
function adjustSlideHeights(sliderEl) {
	const slideHeros = sliderEl.querySelectorAll('.wp-block-gsd-blocks-hero');

	// Reset all slides back to their natural height.
	slideHeros.forEach(heroEl =>
		heroEl.style.height = 'auto'
	)

	const heightList = [...slideHeros].map(heroEl => heroEl.offsetHeight);

	const maxHeight = Math.max(...heightList);

	slideHeros.forEach(heroEl =>
		heroEl.style.height = maxHeight + 'px'
	)
}

function mountSlider(slider) {
	/**
	 * For screen readers.
	 */
	const liveregion = document.createElement('div');
	liveregion.setAttribute('aria-live', 'polite');
	liveregion.setAttribute('aria-atomic', 'true');
	liveregion.setAttribute('class', 'liveregion visuallyhidden');
	slider.appendChild(liveregion);

	const options = {
		bound: true,
		peek: 0,
		perView: 1,
		gap: 0,
	};

	const element = slider.querySelector('.glide');

	if (!element) {
		return;
	}

	const slides = element.querySelectorAll('.glide__slide');
	const bulletContainer = element.querySelector('.glide__bullets__container');

	// adjustSlideHeights(element);

	// let resizeTimer;
	// window.addEventListener(
	// 	'resize',
	// 	() => {
	// 		clearTimeout(resizeTimer);
	// 		resizeTimer = setTimeout(() => {
	// 			adjustSlideHeights(element)
	// 		}, 100);
	// 	}
	// );

	/**
	 * Create the dot buttons at the bottom of the carousel
	 */
	const hasDotNavigation = ! slider.classList.contains('arrow');
	if (hasDotNavigation) {
		let dotButtonsHtml = '';
		for (let j = 0; j < slides.length; j++) {
			dotButtonsHtml +=
				`<button class="glide__bullet" data-glide-dir="=${j}">
<span class="visuallyhidden">Slide ${(j + 1)}</span>
</button>`;
		}

		bulletContainer.querySelector('.glide__bullets').innerHTML = dotButtonsHtml;
	}

	const isAutoplaying = element.classList.contains('animation_auto');
	if (isAutoplaying) {
		options.autoplay = 4000;

		const playIconBtn = `<button class="play-control-btn hidden" data-action="play" aria-label="Play Slider">
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
		<path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z"/>
	</svg>
</button>`;
		const pauseIconBtn = `<button class="play-control-btn" data-action="pause" aria-label="Pause Slider">
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
		<path d="M14.016 5.016H18v13.969h-3.984V5.016zM6 18.984V5.015h3.984v13.969H6z"/>
	</svg>
</button>`;

		bulletContainer.insertAdjacentHTML('beforeend', playIconBtn);
		bulletContainer.insertAdjacentHTML('beforeend', pauseIconBtn);
	}

	const glide = new Glide(element, options);

	glide.on('move', function () {
		slider.querySelector('.liveregion').textContent =
			`Item ${glide.index + 1} of ${slides.length}`;
		slides.forEach((slide, index) => {
			slide.setAttribute('aria-hidden', index !== glide.index);

			// changing the bullet buttons' active class at the beginning of the transition
			if (hasDotNavigation) {
				const bulletButtons = bulletContainer.querySelector('.glide__bullets').children;
				for (let c = 0; c < bulletButtons.length; c++) {
					bulletButtons[c].classList.remove(
						'glide__bullet--active'
					);
				}

				bulletButtons[glide.index].classList.add(
					'glide__bullet--active'
				);
			}
		});
	});

	slider.querySelectorAll('.play-control-btn').forEach(el => {
		el.addEventListener('click', () => {
			if (el.getAttribute("data-action") === "play") {
				glide.update(options);
			} else {
				// We use options here because Glide wasn't respecting its own
				// start/stop methods. This will enable or disable autoplay, however.
				glide.update({...options, autoplay: false});
			}

			slider.querySelectorAll('.play-control-btn').forEach(
				el => el.classList.toggle('hidden')
			);
		});
	});

	glide.mount();
}

function slider() {
	const sliders = document.querySelectorAll('.gsd-hero-carousel');

	if (sliders.length > 0) {
		sliders.forEach(slider => {
			mountSlider(slider);
		})
		return true;
	}
	return false;
}

(function () {
	slider();
})();
export default slider;
